export interface TargetMetric {
  accuracy: number; // percentage
  sop: number; // decimal value
}

export interface TrainingLevel {
  passing: TargetMetric;
  receiving: TargetMetric;
  awareness: TargetMetric;
  finishing: TargetMetric;
}

export const TRAINING_LEVELS: Record<string, TrainingLevel> = {
  '1': {
    passing: {accuracy: 0.4, sop: 5.5},
    receiving: {accuracy: 0.4, sop: 5.5},
    awareness: {accuracy: 0.4, sop: 5.5},
    finishing: {accuracy: 0.2, sop: 6.0},
  },
  '2': {
    passing: {accuracy: 0.5, sop: 5},
    receiving: {accuracy: 0.5, sop: 5},
    awareness: {accuracy: 0.5, sop: 5},
    finishing: {accuracy: 0.2, sop: 5.5},
  },
  '3': {
    passing: {accuracy: 0.5, sop: 5},
    receiving: {accuracy: 0.5, sop: 5},
    awareness: {accuracy: 0.5, sop: 5},
    finishing: {accuracy: 0.2, sop: 5.5},
  },
  '4': {
    passing: {accuracy: 0.75, sop: 4},
    receiving: {accuracy: 0.75, sop: 4},
    awareness: {accuracy: 0.75, sop: 4},
    finishing: {accuracy: 0.4, sop: 4.5},
  },
  '5': {
    passing: {accuracy: 0.75, sop: 4},
    receiving: {accuracy: 0.75, sop: 4},
    awareness: {accuracy: 0.75, sop: 4},
    finishing: {accuracy: 0.4, sop: 4.5},
  },
  '6': {
    passing: {accuracy: 0.75, sop: 4},
    receiving: {accuracy: 0.75, sop: 4},
    awareness: {accuracy: 0.75, sop: 4},
    finishing: {accuracy: 0.4, sop: 4.5},
  },
  '7': {
    passing: {accuracy: 80, sop: 3.8},
    receiving: {accuracy: 80, sop: 3.8},
    awareness: {accuracy: 75, sop: 3.8},
    finishing: {accuracy: 40, sop: 4.5},
  },
  '8': {
    passing: {accuracy: 0.8, sop: 3.8},
    receiving: {accuracy: 0.8, sop: 3.8},
    awareness: {accuracy: 0.75, sop: 3.8},
    finishing: {accuracy: 0.4, sop: 4.5},
  },
  '9': {
    passing: {accuracy: 0.8, sop: 3.8},
    receiving: {accuracy: 0.8, sop: 3.8},
    awareness: {accuracy: 0.75, sop: 3.8},
    finishing: {accuracy: 0.4, sop: 4.5},
  },
};

export const getTargetValuesFromLevelAndFocus = (level: string, focus: string): TargetMetric => {
  const levelData = TRAINING_LEVELS[level];
  if (!level || !focus || !levelData || !(focus in levelData)) {
    return {accuracy: 0, sop: 0};
  }
  return levelData[focus as keyof TrainingLevel];
};
